document.addEventListener('DOMContentLoaded', function() {
  class SlideshowComponent {
    constructor(element) {
      this.slideshow = element;
      this.slider = this.slideshow.querySelector('.slider');
      this.dots = this.slideshow.querySelectorAll('.slider-counter__link');
      this.desktopSlides = this.slideshow.querySelectorAll('.desktop-slide');
      this.mobileSlides = this.slideshow.querySelectorAll('.mobile-slide');
      this.prevButton = this.slideshow.querySelector('.slider-button--prev');
      this.nextButton = this.slideshow.querySelector('.slider-button--next');
      this.autoPlaySpeed = parseInt(this.slider.dataset.speed) * 1000 || 5000;
      this.autoPlayTimer = null;
      this.currentIndex = 0;
      this.isAutoPlayEnabled = this.slider.dataset.autoplay === 'true';
      this.isMobileView = null;
      this.init();
    }

    init() {
      this.bindEvents();
      this.updateSlider();
      if (this.isAutoPlayEnabled) {
        this.startAutoPlay();
      }
    }

    bindEvents() {
      window.addEventListener('resize', this.handleResize.bind(this));
      this.slider.addEventListener('scroll', this.updateActiveDot.bind(this));
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', (e) => {
          e.preventDefault();
          this.scrollToSlide(index);
          this.restartAutoPlay();
        });
      });
      if (this.prevButton) {
        this.prevButton.addEventListener('click', this.goToPrevSlide.bind(this));
      }
      if (this.nextButton) {
        this.nextButton.addEventListener('click', this.goToNextSlide.bind(this));
      }
    }

    handleResize() {
      const wasMobile = this.isMobileView;
      this.isMobileView = this.isMobile();

      if (wasMobile !== this.isMobileView) {
        this.updateSlider();
        this.restartAutoPlay();
      }
    }

    isMobile() {
      return window.innerWidth < 750;
    }

    getSlides() {
      return this.isMobile() ? this.mobileSlides : this.desktopSlides;
    }

    updateSlider() {
      this.scrollToSlide(this.currentIndex, false);
      this.updateActiveDot();
    }

    scrollToSlide(index, smooth = true) {
      const slides = this.getSlides();
      if (index >= slides.length) index = 0;
      if (index < 0) index = slides.length - 1;

      this.currentIndex = index;
      const slide = slides[index];
      if (slide) {
        this.slider.scrollTo({
          left: slide.offsetLeft,
          behavior: smooth ? 'smooth' : 'auto'
        });
      }
      this.updateActiveDot();
    }

    updateActiveDot() {
      const activeIndex = Math.round(this.slider.scrollLeft / this.slider.offsetWidth);
      this.dots.forEach((dot, index) => {
        if (index === activeIndex) {
          dot.classList.add('slider-counter__link--active');
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.classList.remove('slider-counter__link--active');
          dot.removeAttribute('aria-current');
        }
      });
    }


goToPrevSlide() {
  const slides = this.getSlides();
  // Verifica si estamos en mobile
  if (this.isMobileView) {
    // Si estamos en el primer slide, ve al último
    if (this.currentIndex === 0) {
      this.scrollToSlide(slides.length - 1);
    } else {
      this.scrollToSlide(this.currentIndex - 1);
    }
  } else {
    // Comportamiento normal para desktop
    if (this.currentIndex === 0) {
      this.scrollToSlide(0); // Mantén el primer slide
    } else {
      this.scrollToSlide(this.currentIndex - 1);
    }
  }
  this.restartAutoPlay();
}
    goToNextSlide() {
      this.scrollToSlide(this.currentIndex + 1);
      this.restartAutoPlay();
    }

    autoPlay() {
      this.scrollToSlide(this.currentIndex + 1);
    }

    startAutoPlay() {
      this.stopAutoPlay();
      this.autoPlayTimer = setInterval(() => this.autoPlay(), this.autoPlaySpeed);
    }

    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
      }
    }

    restartAutoPlay() {
      if (this.isAutoPlayEnabled) {
        this.stopAutoPlay();
        setTimeout(() => {
          this.startAutoPlay();
        }, 2000);
      }
    }
  }

  // Inicializar todos los slideshows en la página
  const slideshows = document.querySelectorAll('slideshow-component');
  slideshows.forEach(slideshow => new SlideshowComponent(slideshow));
});


